import clsx from 'clsx';
import { CheckIcon, CheckboxCheckedIcon, CheckboxUncheckedIcon } from '../icons';
import styles from './Checkbox.module.css';

export function Checkbox({
  checked = false,
  onChange,
  disabled = false,
  readOnly = false,
  className = '',
  ariaLabel,
  name,
  value,
  tone = 'default',
}) {
  const rootClassName = clsx(styles.root, tone === 'danger' && styles.toneDanger, className);

  return (
    <span className={clsx(rootClassName)}>
      <input
        className={clsx(styles.input)}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        readOnly={readOnly}
        aria-label={ariaLabel}
        name={name}
        value={value}
      />
      <span className={clsx(styles.control)} aria-hidden="true">
        <CheckboxUncheckedIcon className={clsx(styles.uncheckedIcon)} />
        <CheckboxCheckedIcon className={clsx(styles.backgroundIcon)} />
        <CheckIcon className={clsx(styles.icon)} />
      </span>
    </span>
  );
}
